import React from 'react';
import PropTypes from 'prop-types';
import { t } from '../../../../modules/infra/i18n';

const SoldTopList = ({ items, title }) => (
  <div className="c-report-panel">
    <div className="c-heading--small u-co-primary u-type--bold u-type--uppercase u-mb">
      {title || t('reports:charts.most_booked_services')}
    </div>
    <ol className="u-pl+">
      {items.map((item, index) => (
        <li className="u-mb" key={item.id} data-automation-id={`text:mostBooked:${index}:name`}>
          {item.name}{' '}
          <span className="u-co-primary" data-automation-id={`text:mostBooked:${index}:quantity`}>
            ({item.value})
          </span>
        </li>
      ))}
    </ol>
  </div>
);
SoldTopList.propTypes = {
  items: PropTypes.arrayOf(PropTypes.object),
  title: PropTypes.string,
};
SoldTopList.defaultProps = {
  items: [],
  title: null,
};

export default SoldTopList;
